import {
  USER_SET_ID,
  USER_SET_ROLE,
  USER_SET_FLOW,
  USER_SET_FLOW_HAS_IMAGES,
  USER_SET_FLOW_STATE,
  USER_SET_MANAGE_DAMAGE_APPOINTMENT_FLOW_RESULT,
  USER_SET_MANAGE_DAMAGE_BILLMA_FLOW_RESULT
} from './types'

export default {
  [USER_SET_ID] (state, payload) {
    state.userId = payload
  },
  [USER_SET_ROLE] (state, payload) {
    state.userRole = payload
  },
  [USER_SET_FLOW] (state, payload) {
    state.userFlow = payload
  },
  [USER_SET_FLOW_HAS_IMAGES] (state, payload) {
    if (typeof payload === 'boolean') {
      state.userFlowHasImages = payload
    }
  },
  [USER_SET_FLOW_STATE] (state, payload) {
    state.userFlowState = payload
  },
  [USER_SET_MANAGE_DAMAGE_APPOINTMENT_FLOW_RESULT] (state, payload) {
    state.userManageDamageAppointmentFlowResult = payload
  },
  [USER_SET_MANAGE_DAMAGE_BILLMA_FLOW_RESULT] (state, payload) {
    state.userManageDamageBillmaFlowResult = payload
  }
}
